declare global {
  interface Window {
    gtag: (type: string, event?: string, data?: object) => void;
    dataLayer:
      | Array<{
          event: string;
          [key: string]: any;
        }>
      | undefined;
  }
}

export type EventProps = {
  [key: string]: string | number;
};

/**
 *
 * @param url : path of current page
 * @param gTag : google tracking Id
 *
 * @guide https://developers.google.com/analytics/devguides/collection/gtagjs/pages
 */
export const gaTrackPageView = (url: string, gTag?: string) => {
  window.gtag('config', gTag, {
    page_path: url,
  });
};

/**
 *
 * @guide https://developers.google.com/analytics/devguides/collection/gtagjs/events
 */
// export const gaTrackEvent = (action: string, props: EventProps) => {
//   const {category, label, value} = props || {};

//   window.gtag('event', action, {
//     event_category: category,
//     event_label: label,
//     value: value,
//   });
// };

export const gaTrackCustomEvent = (action: string, customParams: object) => {
  window.gtag('event', action, {
    ...customParams,
    non_interaction: true,
  });

  /** For Testing purpose */
  window.dataLayer = window.dataLayer || [];

  if (window.dataLayer) {
    window.dataLayer.push({
      event: action,
      ...customParams,
    });
  }
};

/**
 *
 * @guide https://developers.google.com/analytics/devguides/collection/gtagjs/exceptions
 */
export const gaTrackError = (err: unknown) => {
  window.gtag('event', 'execption', {
    description: err,
    fatal: false,
  });
};
